module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/dial-numbers-aa3df47212d477cc1dde5c399a1c935f.svg";